import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { User } from '../classes';
import { ToastService } from '../services/toast.service';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {
  /* Global variables */
  tokenName: string = 'EXCHANGE_JWT';
  storagedUser: any = {};
  user: User;
  header: Array<any> = [];

  check: boolean = false;

  constructor(
    private cookie: CookieService,
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService
  ) {
    if (localStorage.getItem('header'))
      this.header = JSON.parse(localStorage.getItem('header'));
    if (localStorage.getItem('user'))
      this.storagedUser = JSON.parse(localStorage.getItem('user'));
  }

  checkPage(id) {
    this.check = false;
    this.header.forEach(head => {
      if (head.key == id) {
        this.check = true;
      }
    });
    if (!this.check) {
      this.goToHome();
    }
  }

  getToken() {
    return this.cookie.get(this.tokenName);
  }

  checkLogin() {
    const token = this.cookie.get(this.tokenName);
    if (token) {
      this.checkToken(token)
        .subscribe(
          resp => {
            console.log(resp);
            this.user = resp.user;
            this.goToHome();
          },
          err => console.error(err)
        );
    }
  }

  cleanDate(data){
    let date = new Date(data);
        if (date.getMonth() + 1 >= 10 && date.getDate() >= 10) {
          data = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
          // console.log("mese e giorno >10" , data)
        } else {

          if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
            data = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/'  + date.getFullYear();
            // console.log("mese e giorno <10", data)
          } else {

            if (date.getMonth() + 1 < 10) {
              data = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear();
              // console.log("mese <10", data)
            }

            if (date.getDate() < 10) {
              data = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
              // console.log("giorno <10", data)
            }
          }
        }
        return data;
  }

  cleanDateAndHour(data){
    let date = new Date(data);
    let minuts;
    if(date.getMinutes()< 10){
      minuts = `0${date.getMinutes()}`
    } else {
      minuts = date.getMinutes();
    }
        if (date.getMonth() + 1 >= 10 && date.getDate() >= 10) {
          data = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours()) + ':' + minuts;
          // console.log("mese e giorno >10" , data)
        } else {

          if (date.getMonth() + 1 < 10 && date.getDate() < 10) {
            data = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours()) + ':' + minuts;
            // console.log("mese e giorno <10", data)
          } else {

            if (date.getMonth() + 1 < 10) {
              data = '' + (date.getDate()) + '/' + '0' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours()) + ':' + minuts;
              // console.log("mese <10", data)
            }

            if (date.getDate() < 10) {
              data = '' + (date.getDate()) + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours()) + ':' + minuts;
              // console.log("giorno <10", data)
            }
          }
        }
        return data;
  }

  checkToken(token): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.checkTokenURL, httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  /* SERVICES */
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      console.log("Error status: ", error.status);

      if (error.status == 0) {
        console.error("IMPOSSIBILE CONNETTERSI AL SERVER");
      }
      else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.error}`);
      }
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  };

  /* Locale  */
  // protected server = 'localhost';
  // protected port = ':3005';
  // base = `http://${this.server}${this.port}`;

  /* Online */
  protected server = 'test.adesuite.com/gestserv/service';
  protected port = '';
  base = `https://${this.server}${this.port}`;

  // CheckToken
  checkTokenURL = `${this.base}/login/checktoken`;
  // Login
  loginURL = `${this.base}/login`;
  // secondLogin
  secondLoginURL(id) {
    return `${this.base}/userlogin/${id}`;
  }
  // Logout
  logoutURL = `${this.base}/logout`;
  // Anagrafica
  getTypesURL = `${this.base}/operator/types`;
  getRegistryURL = `${this.base}/operator/registry`;
  getUpdatePersonURL(id) {
    return `${this.base}/operator/updateperson/${id}`;
  }
  addPersonURL = `${this.base}/operator/addperson`;
  getDelPersonURL(id) {
    return `${this.base}/operator/delperson/${id}`;
  }

  //Documentary
  getRoot = `${this.base}/alfresco/root`;
  getFolderContent(id) {
    return `${this.base}/alfresco/folder/${id};`;
  }
  newFolder(parentF, nameF) {
    return `${this.base}/alfresco/newfolder/${parentF}/${nameF}`;
  }
  deleteFolder(id) {
    return `${this.base}/alfresco/delfolder/${id}`;
  }
  updateFolderName(id) {
    return `${this.base}/alfresco/changefoldername/${id}`;
  }

  getUploadFileURL(id) {
    return `${this.base}/alfresco/uploadfile/${id};`;
  }
  getNewFolderURL(id) {
    return `${this.base}/alfresco/newfolder/${id};`;
  }


  //setNodePermission
  setNodePermission(id) {
    return `${this.base}/alfresco/setnodeauth/${id}`;
  }
  //getNodePermission
  getNodePermission(id) {
    return `${this.base}/alfresco/getnodeauth/${id}`
  }

  //UploadFile
  uploadFile(id) {
    return `${this.base}/alfresco/uploadfile/${id}`
  }

  //getContent
  getContent(id) {
    return `${this.base}/alfresco/getcontent/${id}`
  }

  getGroup(id) {
    return `${this.base}/group/${id}`
  }

  //TICKET
  newTicket = `${this.base}/ticket/new`
  newTicketFile(id) {
    return `${this.base}/ticket/new/file/${id}`
  }
  getTickets = `${this.base}/ticket/tickets`

  getTIcket(id) {
    return `${this.base}/ticket/${id}`
  }

  assignTicket(ticketId, userId) {
    return `${this.base}/ticket/${ticketId}/assign/${userId}`
  }

  getOperatorAssigned(id) {
    return `${this.base}/ticket/${id}/operators`
  }

  getTicketsCustomer(id) {
    return `${this.base}/ticket/${id}/customers`
  }

  setStatus(id) {
    return `${this.base}/ticket/${id}/status`;
  }
  sendCommunication(id) {
    return `${this.base}/ticket/${id}/communication`
  }

  getTicketCommunications(id) {
    return `${this.base}/ticket/${id}/communications`
  }

  getOperatorTickets = `${this.base}/ticket/get/operatorticket`


  //Group
  newGroupURL = `${this.base}/group/new`;
  getGroupsURL = `${this.base}/groups`;
  getGetGroupURL(id) {
    return `${this.base}/group/${id}`;
  }
  getUpdateGroupNameURL(id) {
    return `${this.base}/group/updatename/${id}`;
  }
  getAddMembersToGroupURL(id) {
    return `${this.base}/group/${id}/addmember`;
  }
  getDelMembersGroupURL(id) {
    return `${this.base}/group/${id}/removemember`;
  }
  getDeleteGroupURL(id) {
    return `${this.base}/group/${id}/delete`;
  }
  //setGroups
  // updateGroup

  // Homrpsgr
  getHomePageURL = `${this.base}/homepage/home`;
  //Operator
  getOperator = `${this.base}/operator/getusers`;
  //newOperator
  addOperator = `${this.base}/operator/newuser`;
  //richiedi profili
  getProfile = `${this.base}/profiles`;
  getCustomerProfile = `${this.base}/customer/profiles`
  getOperatorProfile = `${this.base}/operator/profiles`;
  operatorDisponibilityURL = `${this.base}/operator/free`;
  getOperatorPageURL = `${this.base}/operator/initpage`;
  //delete profili
  deleteProfile(id) {
    return `${this.base}/deluser/${id}`;
  }
  updateUser(id) {
    return `${this.base}/operator/updateuser/${id}`;
  }

  //Customer
  downloadPFCsvURL = `${this.base}/customers/from/csv/pf`
  downloadPGCsvURL = `${this.base}/customers/from/csv/pg`
  getCustomer = `${this.base}/getcustomers`;
  getGetCustomer(id) {
    return `${this.base}/customer/get/${id} `;
  }
  //addCustomer
  addCustomer = `${this.base}/addcustomer`;
  //updateCustomer
  updateCustomer(id) {
    return `${this.base}/updatecustomer/${id}`;
  }
  //deleteCustomer
  deleteCustomer(id) {
    return `${this.base}/delcustomer/${id}`;
  }
  customerDisponibilityURL = `${this.base}/customers/free`;

  //User
  newUser = `${this.base}/customer/newuser`;
  //Get user of customer
  getUser(id) {
    return `${this.base}/customer/getusers/${id}`;
  }
  //Set user
  setUser(id) {
    return `${this.base}/customer/setuser/${id}`;
  }
  //Get all user
  getUAllUser = `${this.base}/users/customer`;

  // Account
  getGetInactiveAccountURL(id) {
    return `${this.base}/account/inactive/${id}`;
  }
  updateAccountURL = `${this.base}/account/update`;
  getProfileURL = `${this.base}/account/profile`;


  // CONTRACT
  getNewContractURL = `${this.base}/contract/new`;
  getGetContractsURL = `${this.base}/contract/list`;
  getGetContractURL(id) {
    return `${this.base}/contract/${id}`;
  }
  getUpdateContractURL(id) {
    return `${this.base}/contract/${id}`;
  }
  getDeleteContractURL(id) {
    return `${this.base}/contract/${id}`;
  }
  getGetAssocContractToCustomerURL(contractId) {
    return `${this.base}/contract/${contractId}/assoctocustomers`;
  }
  getGetAssocedCustomerToContractURL(contractId) {
    return `${this.base}/contract/${contractId}/assoctocustomers`
  }

  // Upload csv
  uploadCsvURL = `${this.base}/customer/add/fromcsv`;

  // PROCCES

  getNewProccesURL = `${this.base}/procces/new`;
  getGetProccesURL = `${this.base}/procces/list`;
  getRunProccesCusURL(id) {
    return `${this.base}/bpmn/start/cus/${id}`;
  }
  getRunProccesGroupURL(id) {
    return `${this.base}/bpmn/start/group/${id}`;
  }
  getProccesInstanceURL(id) {
    return `${this.base}/bpmn/procces/instance/${id}`;
  }
  getTypeDeadline(id){
    return `${this.base}/procces/deadline/${id}/type`;
  }
  getInputInstance = `${this.base}/bpmn/input/test`;

  // CALENDAR
  getEventsURL = `${this.base}/calendar/event/list`;
  storActivityURL(id){
     return `${this.base}/calendar/event/filed/${id}`;
  }
  /* ROOT */

  // PREIMPOSTATE
  goToHome() {
    this.router.navigate(['/homepage']);
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }
  // GENERALE
  goTo(location: string) {
    this.router.navigate([`/${location}`]);
  }


  /* ERROR SNIFFER */
  errorSniffer(err) {
    let tk = this.tokenName
    let errToken = err.code.indexOf("JWT");
    if (errToken > -1) {
      console.error(err);
      this.goToLogin();
      this.cookie.delete(tk)
      this.toastService.show("La tua sessione è scaduta, effettua nuovamente il login", {
        classname: 'bg-danger text-light',
        delay: 5000,
        autohide: true,
        headertext: 'Toast Header'
      });
    }
  }

  removeCache() {
    let tk = this.tokenName
    this.cookie.delete(tk)
    localStorage.removeItem('header');
    localStorage.removeItem('user');
  }

  // Servizi homepage
  getHome(token): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.getHomePageURL, httpOptions).pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
}
